<!--
 * @Description : 手机端首页
 * @Author      : pishengjun
 * @Date        : 2026-03-03 10:06:14
-->
<template>
  <div class="mobile-tip">
    <!-- 微信环境提示 -->
    <div v-if="isWeChat()" class="wechat-tip">
      <div class="wechat-tip-content">
        <!-- 点击右上角选择在浏览器中打开 -->
        <img class="tip-icon" src="@/assets/images/weixin-tiplayer.png" alt="" />
      </div>
    </div>
    <div class="mobile-tip-header">
      <div class="logo">
        <img class="logoImg" :src="MinioToolsClass.getMinioFileCompleteUrl(webSystemSetting?.logo || '')" />
      </div>
      <div class="webSiteName">{{ webSystemSetting?.webSiteName }}</div>
    </div>

    <div class="mobile-tip-content">
      <div class="welcome-text">欢迎使用{{ webSystemSetting?.webSiteName }}</div>
      <div class="mobile-tip-button">
        <a href="#" @click="openAlipayMiniProgram" class="alipay-button">
          <span class="button-icon">📱</span>
          打开支付宝小程序
        </a>
      </div>
      <div class="tip-text">请在支付宝中打开小程序获得更好体验</div>
    </div>

    <div class="mobile-tip-footer">
      <div class="mobile-tip-footer-item">Copyright © {{ new Date().getFullYear() }} {{ webSystemSetting?.copyright }} 版权所有</div>
      <div class="mobile-tip-footer-item">{{ webSystemSetting?.icpFiling }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { store } from "@/store";
import { MinioToolsClass } from "@/utils/minioToolsClass";
import { message } from "ant-design-vue";
import { computed, defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  setup() {
    const state = reactive({});
    const event = {
      openAlipayMiniProgram() {
        const appId = webSystemSetting.value?.alipayAppId;
        const tenantAccessId = webSystemSetting.value?.id;
        if (!appId) {
          message.error("未配置支付宝小程序AppID");
          return;
        }

        // urlencode编码
        const query = encodeURIComponent("tenantAccessId=" + tenantAccessId);

        const scheme = `alipays://platformapi/startApp?appId=${appId}&query=${query}`;
        console.log("支付宝小程序URL:", scheme);

        const universalLink = `https://ds.alipay.com/?scheme=${encodeURIComponent(scheme)}`;

        // window.location.href = universalLink;
        window.open(universalLink);
      },
    };
    const webSystemSetting = computed(() => store.state.webSystemSetting);

    // 添加微信环境检测函数
    const isWeChat = () => {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes("micromessenger");
    };

    return {
      ...toRefs(state),
      ...event,
      webSystemSetting,
      MinioToolsClass,
      isWeChat,
    };
  },
});
</script>

<style lang="less" scoped>
.mobile-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100vh;
  background: #4096ff;
  padding: 40px 20px 30px;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  position: relative;

  // 微信环境提示
  .wechat-tip {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.7);
    .tip-icon {
      width: 100%;
    }
  }

  .mobile-tip-header {
    text-align: center;
    margin-bottom: 40px;

    .logo {
      margin-bottom: 20px;

      .logoImg {
        max-width: 80%;
        max-height: 120px;
        border-radius: 12px;
      }
    }

    .webSiteName {
      font-size: 28px;
      font-weight: 700;
      color: #fff;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      letter-spacing: 1px;
    }
  }

  .mobile-tip-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 400px;
    text-align: center;

    .welcome-text {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 30px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.5;
    }

    .mobile-tip-button {
      width: 100%;
      margin-bottom: 20px;

      .alipay-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 18px 32px;
        background: linear-gradient(135deg, #00aaff 0%, #0088ff 100%);
        border-radius: 50px;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        text-decoration: none;
        box-shadow: 0 6px 10px rgba(0, 136, 255, 0.7);
        transition: all 0.3s ease;
        border: 1px solid rgba(255, 255, 255, 0.2);

        .button-icon {
          margin-right: 10px;
          font-size: 24px;
        }
      }
    }

    .tip-text {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      margin-top: 10px;
    }
  }

  .mobile-tip-footer {
    margin-top: 40px;
    text-align: center;

    .mobile-tip-footer-item {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }
}
</style>

<style lang="less">
@media (max-width: 700px) {
  html body {
    background: #4096ff;
  }
}
</style>
